var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.fileNames),function(file){return _c('v-img',{key:file,attrs:{"src":'/assets/manual/' + file,"width":"100%","contain":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }